import React, { FC, ReactNode } from 'react';
import { Modal, Box } from '@mui/material';

type ReusableModalProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  width?: number | string; // Optional width prop
  height?: number | string; // Optional height prop
};

const CustomModal: FC<ReusableModalProps> = ({
  isOpen,
  onClose,
  children,
  width = 400, // Default width
  height = 'auto', // Default height
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby='modal-title'
      aria-describedby='modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: width,
          maxHeight: '90vh',
          overflowY: 'auto',
          height: height,
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column', // Add this line for scrollable content
        }}
      >
        {/* <Typography id="modal-title" variant="h6" component="h2">
          Modal Title
        </Typography>
        <Box id="modal-description" sx={{ mt: 2 }}>
          {children}
        </Box>
        <Button onClick={onClose} sx={{ mt: 2 }}>
          Close
        </Button> */}
        {children}
      </Box>
    </Modal>
  );
};

export default CustomModal;
